import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'
import moment from 'moment'

// components
import OrderDetail from '../../components/orderDetail/OrderDetail'
import MoOrderDetail from '../../components/moOrderDetail/MoOrderDetail'
import { HeaderTab } from '../../components'
import OrderDateBox from '../../components/orderDetail/OrderDateBox'

// globals
import * as TYPE from '../../globals/type'
import * as constants from '../../globals/constants'

// utils
import { useAxios } from '../../utils/useAxios'

// [  주문현황 ]
const TodayOrderList = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800)
  const [send, setSend] = useState(location?.state?.orderNum)
  const [data, setData] = useState()
  const [agentPOSData, setAgentPOSData] = useState()
  const [orderNum, setOrderNum] = useState(location?.state?.orderNum)
  const [logId, setLogId] = useState(location?.state?.logId) //agentpos에서 넘어올때 쌓는 로그 아이디 값
  const { fetchData, loading, orderData, error } = useAxios()

  // pc / tablet
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 800)
  }
  const getItems = async () => {
    const params = {
      size: 10,
      page: 1,
      orderType: send?.orderType,
      detailType: send?.orderDetail,
      orderStatus: send?.orderState,
      deliveryStatus: send?.orderDelivery,
      orderNum: orderNum,
      orderMode: 'TODAY',
      startDate: send?.startDate,
      endDate: send?.endDate,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    }

    fetchData(
      constants.API.ORDERS_LIST,
      'GET', // method
      null, // body
      params, // params
    )
  }

  useEffect(() => {
    if (orderNum) {
      getItems()
    }
  }, [orderNum])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  // agentPOS: 주문번호 검색 성공 로그 저장하기
  const setOrderSearchLog = () => {
    const params = {
      logId: logId,
    }

    fetchData(
      constants.API.ORDER_SEARCH_LOG,
      'GET', // method
      null, // body
      params, // params
    )
  }
  useEffect(() => {
    if (orderData) {
      setOrderSearchLog()
      setAgentPOSData(orderData)
    }
  }, [orderData])
  const handleTab = (flag) => {
    switch (flag) {
      case 0:
        return

      case 1:
        return navigate(`/${TYPE.TAB_URL.SELECT_ORDER_LIST}`, {
          replace: false,
        })

      default:
        break
    }
  }

  return (
    <>
      <OrderListWrap>
        <HeaderTab
          headerItem={['당일 주문현황', '기간별 주문현황']}
          selectedItem={0}
          maxWidth={984}
          handleItem={handleTab}
        />
        <div className="mobileBox">
          <OrderDateBox
            orderDate={'today'}
            setSend={setSend}
            data={data}
            orderNum={orderNum}
            isMobile={isMobile}
            type={send?.orderType}
          />
        </div>
        <ReponsiveWrap>
          {isMobile ? (
            <div className="mobile-content">
              <MoOrderDetail
                send={send}
                orderMode={'TODAY'}
                setData={setData}
                agentPOSData={agentPOSData}
                orderNum={orderNum}
              />
            </div>
          ) : (
            <div className="desktop-content">
              <OrderDetail
                send={send}
                orderMode={'TODAY'}
                setData={setData}
                agentPOSData={agentPOSData}
                orderNum={orderNum}
              />
            </div>
          )}
        </ReponsiveWrap>
      </OrderListWrap>
    </>
  )
}

export default TodayOrderList

const OrderListWrap = styled.section`
  width: 100%;
  max-width: 984px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;

  .boxShadow {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    padding: 64px 30px 50px;
  }

  .mobileBox {
    margin-bottom: 42px;
    @media ${(props) => props.theme.tablet} {
      padding: 20px 20px 30px;
    }
  }
`
const ReponsiveWrap = styled.div`
  .mobile-content {
    @media ${(props) => props.theme.desktop} {
      display: none;
    }
    @media (max-width: 800px) {
      display: block;
    }
  }
  .desktop-content {
    @media ${(props) => props.theme.desktop} {
      display: block;
    }
    @media (max-width: 800px) {
      display: none;
    }
  }
`
